import styled from "styled-components";
import grey from "../colors/grey";
export var DropdownButton = styled.button.withConfig({
  displayName: "styled__DropdownButton",
  componentId: "sc-kes9ha-0"
})(["background:#fff;border:1px solid black;border-radius:5px;color:inherit;padding:5px 7px;transition:all 0.1s ease-in-out;span.caret{border-left:4px solid transparent;border-right:4px solid transparent;border-top:4px solid;color:inherit;display:inline-block;height:0;margin-left:5px;vertical-align:middle;width:0;}&:hover,&[aria-expanded=\"true\"]{background:", ";color:black;cursor:pointer;}"], grey[50]);
export var DropdownMenu = styled.div.withConfig({
  displayName: "styled__DropdownMenu",
  componentId: "sc-kes9ha-1"
})(["background-clip:padding-box;background-color:#fff;border-radius:4px;border:1px solid rgba(0,0,0,0.15);box-shadow:0 6px 12px rgba(0,0,0,0.175);color:#333;list-style:none;margin:2px 0 0;min-width:160px;padding:5px 0;position:absolute;", " top:100%;width:100%;z-index:1000;hr{margin:0;padding:0;}a,button{background:transparent;border:none;cursor:pointer;padding:5px 15px;text-align:start;width:100%;&:hover{background:", ";}}"], function (props) {
  return props.alignLeft ? "left: 0;" : "right: 0;";
}, grey[50]);
export var DropdownWrapper = styled.span.withConfig({
  displayName: "styled__DropdownWrapper",
  componentId: "sc-kes9ha-2"
})(["float:", ";position:relative;"], function (props) {
  return props.pullRight ? "right" : "left";
});
//# sourceMappingURL=styled.js.map